import { useState } from 'react';
import { Icons as TemplateIcons } from '../../../../Icons';
import { EmailTemplateModal } from 'pages/Workshop/Transactions/TransactionTasks/components/TaskModalForm/EmailTemplateModal';

import commonStyles from './../../styles.module.scss';
import { Tooltip } from 'components-antd';

export const EmailTemplatePopover = ({ emailTemplate }) => {
  const [open, setOpen] = useState(false);

  if (!emailTemplate) return null;

  return (
    <div>
      <Tooltip
        title="Email Template"
        placement="top"
        trigger="hover"
        overlayClassName={commonStyles.infoTooltip}
      >
        <button
          className={commonStyles.popoverBtn}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }}
        >
          <TemplateIcons variant={TemplateIcons.EMAIL} />
        </button>
      </Tooltip>
      <EmailTemplateModal
        open={open}
        onClose={() => setOpen(false)}
        subjectText={emailTemplate?.Subject}
        bodyText={emailTemplate?.Body}
      />
    </div>
  );
};
